import { useRef, useEffect, useCallback } from 'react'

type IntersectHandler = (entry: IntersectionObserverEntry, observer: IntersectionObserver) => void

const useIntersection = (onIntersect: IntersectHandler, options?: IntersectionObserverInit) => {
  const ref = useRef(null)

  const callback = useCallback(
    (entries: IntersectionObserverEntry[], observer: IntersectionObserver) =>
      entries.forEach((entry) => entry.isIntersecting && onIntersect(entry, observer)),
    [onIntersect],
  )

  useEffect(() => {
    if (!ref.current) return

    const observer = new IntersectionObserver(callback, options)

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [ref, options, callback])

  return ref
}

export default useIntersection
